import { Component, OnInit } from '@angular/core';
import { OAuth } from '../../models/oauth';
import { OAuthService } from '../../services/oauth.service';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-oauth',
  imports: [CommonModule, RouterModule],
  templateUrl: './oauth.component.html',
  styleUrl: './oauth.component.css'
})
export class OauthComponent implements OnInit {
  oauths: OAuth[] = [];

  constructor(public oauthService: OAuthService) { }

  ngOnInit(): void {
    this.oauthService.getOAuths().subscribe({
      next: (result: OAuth[]) => {
        this.oauths = result;
      },
      error: (err: any) => {
        console.log(err);
      }
    });
  }
}
